import { ReactNode } from 'react';

import { Icon, IconButton } from '@atom/mui';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '@atom/mui/icons';
import { pluralize } from '@atom/utilities/stringUtilities';

import classes from './list.module.css';

type ListHeaderProps = {
  count: number;
  label: string;
  open: boolean;
  onToggle: () => void;
  actionIcon?: ReactNode;
  showAction?: boolean;
  actionDisabled?: boolean;
  actionTooltip?: string;
  onAction?: () => void;
  showWhenEmpty?: boolean;
  dataCy?: string;
};

const ListHeader = ({
  count,
  label,
  open,
  onToggle,
  actionIcon,
  showAction = true,
  actionDisabled = false,
  actionTooltip,
  onAction,
  showWhenEmpty = false,
  dataCy,
}: ListHeaderProps) => {
  if (count === 0 && !showWhenEmpty) {
    return null;
  }

  const title = pluralize(count, label);

  return (
    <div className={classes.sectionHeader} data-cy={dataCy}>
      <div className={classes.sectionHeaderTitle}>
        {count} {title}
      </div>
      <div className={classes.sectionHeaderActions}>
        {actionIcon && showAction && (
          <IconButton
            edge="end"
            tooltip={actionTooltip}
            onClick={onAction}
            disabled={actionDisabled}
            data-cy={dataCy && `${dataCy}ActionButton`}
          >
            {actionIcon}
          </IconButton>
        )}
        <IconButton
          onClick={onToggle}
          data-cy={dataCy && `${dataCy}ToggleButton`}
        >
          <Icon icon={open ? KeyboardArrowUpIcon : KeyboardArrowDownIcon} />
        </IconButton>
      </div>
    </div>
  );
};

export default ListHeader;
